import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AdminComponent } from './admin/admin.component';
// import { CloseEventComponent } from './admin/close-event/close-event.component';


import { AdminAuthGuardService } from './auth/admin.auth.guard';

const routes: Routes = [
  {
   path: '',
   redirectTo: 'auth',
   pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
   },
  {
    path: 'user',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule)

  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)

  }
  // ,
  // {
  //   path: 'admin', component: AdminComponent, canActivate: [AdminAuthGuardService],
  //   children: [
  //     { path: 'create-war', component: CreateWarComponent },
  //     { path: 'close-event', component: CloseEventComponent }
  //   ]
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
